import React, { useState, useEffect } from "react";

import { login } from "../../store/user/actions";
import { selectToken } from "../../store/user/selectors";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import "./style.css";

export default function Login(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const history = useHistory();

  useEffect(() => {
    if (token !== null) {
      history.push("/");
    }
  }, [token, history]);

  function submitForm(event) {
    event.preventDefault();

    dispatch(login(email, password));

    setEmail("");
    setPassword("");
    props.closeModal();
  }
  console.log(props);
  return (
    <div class="login">
      <div
        style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}
      >
        <div style={{ color: "white" }} onClick={() => props.closeModal()}>
          x
        </div>
      </div>
      <h1> Login </h1>

      <div class="username">
        <input
          type="text"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="Enter your email"
          required
        ></input>
      </div>

      <div class="password">
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        ></input>
      </div>
      <input type="submit" value="Sign In" onClick={submitForm}></input>
      <p>
        Do you want to create an account?{" "}
        <button onClick={props.loadSignUp}>Sign up</button>
      </p>
    </div>
  );
}
